import { render, staticRenderFns } from "./SummaryTotal.vue?vue&type=template&id=c172f8a6&scoped=true&"
import script from "./SummaryTotal.vue?vue&type=script&lang=js&"
export * from "./SummaryTotal.vue?vue&type=script&lang=js&"
import style0 from "./SummaryTotal.vue?vue&type=style&index=0&id=c172f8a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c172f8a6",
  null
  
)

export default component.exports